var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 1163,
    viewBox: "0 0 546 1163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "m-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M196.431 1066.88C201.849 1026.52 196.431 954.19 242.073 890.123C276.546 848.809 310.295 804.696 310.528 748.403C314.019 658.996 237.481 574.876 141.943 584.065C92.276 588.843 59.4692 609.099 25.246 617.526C7.16747 621.977 27.0446 643.995 40.0604 649.451C79.4757 665.981 98.0369 642.044 140.176 638.214C186.7 633.984 236.395 666.765 249.997 712.28C263.683 756.261 243.219 796.176 215.912 830.17C167.751 890.123 144.495 957.175 141.926 1048.62C138.228 1062.98 135.533 1078.97 139.038 1093.73C143.917 1117.66 173.859 1128.01 187.674 1105.63C193.486 1096.17 194.567 1084.57 196.431 1073.66C197.693 1065.73 193.32 1074.34 196.405 1066.93L196.428 1066.88L196.431 1066.88Z",
    fill: "#DB9CF3",
    stroke: "#A7599C",
    strokeWidth: 6.05347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M76.3249 649.449C80.6983 649.449 84.2436 645.903 84.2436 641.53C84.2436 637.157 80.6983 633.611 76.3249 633.611C71.9516 633.611 68.4062 637.157 68.4062 641.53C68.4062 645.903 71.9516 649.449 76.3249 649.449Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M76.3249 644.978C78.2291 644.978 79.7728 643.434 79.7728 641.53C79.7728 639.626 78.2291 638.082 76.3249 638.082C74.4206 638.082 72.877 639.626 72.877 641.53C72.877 643.434 74.4206 644.978 76.3249 644.978Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M53.8503 646.519C56.7415 646.519 59.0854 644.175 59.0854 641.284C59.0854 638.393 56.7415 636.049 53.8503 636.049C50.959 636.049 48.6152 638.393 48.6152 641.284C48.6152 644.175 50.959 646.519 53.8503 646.519Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M53.8497 643.567C55.1097 643.567 56.1311 642.545 56.1311 641.285C56.1311 640.025 55.1097 639.004 53.8497 639.004C52.5898 639.004 51.5684 640.025 51.5684 641.285C51.5684 642.545 52.5898 643.567 53.8497 643.567Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M120.922 634.063C123.637 634.063 125.838 631.862 125.838 629.147C125.838 626.431 123.637 624.23 120.922 624.23C118.207 624.23 116.006 626.431 116.006 629.147C116.006 631.862 118.207 634.063 120.922 634.063Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M120.924 631.291C122.106 631.291 123.064 630.333 123.064 629.15C123.064 627.968 122.106 627.01 120.924 627.01C119.742 627.01 118.783 627.968 118.783 629.15C118.783 630.333 119.742 631.291 120.924 631.291Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M99.0042 640.698C102.208 640.698 104.805 638.101 104.805 634.897C104.805 631.693 102.208 629.096 99.0042 629.096C95.8004 629.096 93.2031 631.693 93.2031 634.897C93.2031 638.101 95.8004 640.698 99.0042 640.698Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M99.0022 637.416C100.397 637.416 101.528 636.286 101.528 634.891C101.528 633.496 100.397 632.365 99.0022 632.365C97.6073 632.365 96.4766 633.496 96.4766 634.891C96.4766 636.286 97.6073 637.416 99.0022 637.416Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2);
export default __webpack_public_path__ + "static/media/m-2.711b272b8bc6f7ffe59115bfe50f326b.svg";
export { ForwardRef as ReactComponent };